import { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { authService } from "../services/authService";
import Logo from "../components/Logo";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const infoQuery = useQuery({
    queryKey: ["forgot-password", "info"],
    queryFn: () => authService.getForgotPasswordInfo(),
    retry: false,
  });

  const forgotMutation = useMutation({
    mutationFn: ({ email: em }) => authService.forgotPassword({ email: em }),
    onSuccess: (res) => {
      toast.success(res.message);
      setSent(true);
    },
    onError: (err) => {
      toast.error(err?.message || "No se pudo procesar la solicitud");
    },
  });

  function onSubmit(e) {
    e.preventDefault();
    if (!email) {
      toast.error("Introduce tu email");
      return;
    }
    forgotMutation.mutate({ email });
  }

  return (
    <div className="space-y-10" data-testid="forgot-password-page">
      <header className="flex flex-col items-center gap-6 text-center">
        <Logo size={32} />
        <div className="space-y-2">
          <p className="zx-label">Recuperación</p>
          <h1 className="font-serif text-4xl tracking-tight md:text-5xl">
            Dejaste la llave fuera
          </h1>
          <p className="text-sm text-[rgba(255,255,255,0.65)]">
            Te enviaremos un enlace silencioso a tu email.
          </p>
          {infoQuery.data?.message ? (
            <p className="text-xs text-[rgba(255,255,255,0.5)]">{infoQuery.data.message}</p>
          ) : null}
        </div>
      </header>

      {!sent ? (
        <form onSubmit={onSubmit} className="space-y-6" data-testid="forgot-form">
          <div className="space-y-1">
            <label className="zx-label" htmlFor="f-email">Email</label>
            <input
              id="f-email"
              type="email"
              className="zx-input"
              placeholder="tu@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
            />
          </div>
          <button
            type="submit"
            className="zx-btn-primary"
            disabled={forgotMutation.isPending}
            data-testid="forgot-submit-button"
          >
            {forgotMutation.isPending ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>
      ) : (
        <div className="zx-card p-6 text-center text-sm text-[rgba(255,255,255,0.75)]">
          Si el email está registrado, recibirás instrucciones discretas en breve.
        </div>
      )}

      <div className="text-center">
        <Link
          to="/auth"
          className="text-xs uppercase tracking-[0.2em] text-[rgba(255,255,255,0.55)] hover:text-[#f5f5f5]"
          data-testid="forgot-back-link"
        >
          ← Volver al acceso
        </Link>
      </div>
    </div>
  );
}
